// requires third party vendors that are not available in npm (CM)
require('../vendors/index');

// Non polyfill libs (CM) - we keep them separate so that the polyfills are not included in ng1 tests (CM).
window.angular = require('angular');
require('angular-resource');

require('angular-material');
require('angular-material/angular-material.css');

// auth dependencies (CM)
window.auth0 = require('auth0-js');

require('angular-ui-layout'); // registers an angular module called `ui.layout`
require('../node_modules/angular-md5/angular-md5.js');
require('angular-ui-router');
require('angular-filter');
require('ng-rollbar');
require('../node_modules/malarkey/dist/malarkey.js');
require('../node_modules/angular-breadcrumb/dist/angular-breadcrumb.js');
require('../node_modules/angular-jwt/dist/angular-jwt.js');
require('../node_modules/jwt-decode/build/jwt-decode.js');
require('../node_modules/angular-messages/angular-messages.js');
window.agGrid = require('@ag-grid-community/core');
require('../node_modules/angular-material-data-table/dist/md-data-table.js');
require('../node_modules/angular-material-data-table/dist/md-data-table.css');
require('../node_modules/ng-idle/angular-idle.js');
require('../node_modules/flux-angular/release/flux-angular.js');
require('../node_modules/angular-file-saver/dist/angular-file-saver.bundle.js');

require('../node_modules/material-steppers/dist/material-steppers.js');
require('../node_modules/material-steppers/dist/material-steppers.css');

require('../node_modules/angular-sanitize/angular-sanitize.js');
require('../node_modules/object-hash/dist/object_hash.js');
